// colors named using http://chir.ag/projects/name-that-color


const getDynamicColor = (name) => typeof window !== 'undefined' && window?.colors?.[name]

const colors = {
  cerulean: getDynamicColor('cerulean') || '#00A4D1',
  white: getDynamicColor('white') || '#ffffff',
  cornFlowerBlue: getDynamicColor('cornFlowerBlue') || '#ffffff',
  black: getDynamicColor('black') || '#000000',
  azureRadiance: getDynamicColor('azureRadiance') || '#00A2FF',
  galery: getDynamicColor('galery') || '#EBEBEB',
  alizarinCrimson: getDynamicColor('alizarinCrimson') || '#DE1A1A',
  regentGray: getDynamicColor('regentGray') || '#7A8A9E',
  polar: getDynamicColor('polar') || '#F3F9FC',
  christi: getDynamicColor('christi') || '#65A50A',
  guardsmanRed: getDynamicColor('guardsmanRed') || '#D00000',
  mystic: getDynamicColor('mystic') || '#E4EAEC',
  pickledBluewood: getDynamicColor('pickledBluewood') || '#293D4A',
}

export default colors
